export const tooltipPt = {
  root: 'custom-tooltip-container',
  text: 'custom-tooltip-text',
  arrow: 'custom-tooltip-arrow'
};